export default "__VITE_ASSET__BRUTAMuD__"